import { Fragment, React, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { toast } from "react-toastify";
import emailjs from "emailjs-com";

export const Contact = () => {
  const formInitialDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  };

  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState("Send");

  const formFields = [
    { name: "firstName", type: "text", placeholder: "First Name" },
    { name: "lastName", type: "text", placeholder: "Last Name" },
    { name: "email", type: "email", placeholder: "Email Address" },
    { name: "phone", type: "tel", placeholder: "Phone No." },
    { name: "message", type: "textarea", placeholder: "Message" },
  ];

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    });
  };

  const phoneValidation = (phone) => {
    const phoneRegex = /^[0-9]{1,10}$/;
    return phoneRegex.test(phone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonText("Sending...");

    if (!phoneValidation(formDetails.phone)) {
      toast.error("Please enter a valid phone number (1-10 digits).");
      setButtonText("Send");
      return;
    }

    try {
      await emailjs.send(
        "service_nn9c2nm",
        "template_iuittjn",
        {
          from_name: `${formDetails.firstName} ${formDetails.lastName}`,
          from_email: formDetails.email,
          phone: formDetails.phone,
          message: formDetails.message,
          to_email: "ravisachin36@gmail.com",
        },
        "bog2P2ce2t3sPoKA9"
      );

      toast.success("Message sent successfully!");
      setFormDetails({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to send message. Try again!");
    }

    setButtonText("Send");
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <img
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                  src={contactImg}
                  alt="Contact Us"
                />
              )}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Get In Touch</h2>
                  <h6 style={{ marginBottom: "20px" }}>
                    If you have any questions or concerns, please don't hesitate
                    to contact me. I am open to any work opportunities that
                    align with my skills and interests.
                  </h6>
                  <form onSubmit={handleSubmit}>
                    <Row>
                      {formFields.map((field) => (
                        <Fragment key={field.name}>
                          {field.type === "textarea" ? (
                            <Col size={12} sm={12} className="px-1">
                              <textarea
                                rows="6"
                                value={formDetails[field.name]}
                                placeholder={field.placeholder}
                                onChange={(e) =>
                                  onFormUpdate(field.name, e.target.value)
                                }
                              />
                            </Col>
                          ) : (
                            <Col size={12} sm={6} className="px-1">
                              <input
                                type={field.type}
                                value={formDetails[field.name]}
                                placeholder={field.placeholder}
                                onChange={(e) =>
                                  onFormUpdate(field.name, e.target.value)
                                }
                              />
                            </Col>
                          )}
                        </Fragment>
                      ))}
                      <Col size={12} className="px-1">
                        <button type="submit">
                          <span>{buttonText}</span>
                        </button>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
